const actions = {
  RESET_APP: 'RESET_APP',
};
export default actions;